/* eslint-disable import/prefer-default-export */
const ITEM_GRID_COUNT = 4;
const ITEM_GRID_PILLS_COUNT = 4.25;

export { ITEM_GRID_COUNT, ITEM_GRID_PILLS_COUNT };
